// extracted by mini-css-extract-plugin
export default {"button":"BorderGradientButton_button__t5KjN"};